import React from "react";
import { MobXProviderContext } from "mobx-react";

// Sagres Rotas React example components
import { Button, Card, CardContent, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Header from "components/Header/Header";

function PerfilView() {
  const { authStore } = React.useContext(MobXProviderContext);
  const navigate = useNavigate();

  var height = window.innerHeight

  const handleLogout = (e) => {
    e.preventDefault();
    authStore.logout().then(() => {
      navigate("/login");
    });
  };

  return (
    <div>
      <Header />

      <div style={{ position: 'relative', width: '100%', height: `${height - 135}px` }}>

        <Card style={{ height: '105%', margin: '32px', padding: 0, }}>
          <CardContent style={{ padding: 0 }}>
            <Typography gutterBottom variant="h5" component="div" style={{ marginLeft: 5, paddingTop: 16, paddingLeft: 8 }}>
              Perfil
            </Typography>

            <Grid container  direction="column" spacing={1} padding={3}>
              <div>Nome: {authStore.usuario.Nome}</div>
              <div>Login: {authStore.usuario.Login}</div>
              <div>NomePublico: {authStore.usuario.NomePublico}</div>
              <div>UsuarioId: {authStore.usuario.UsuarioId}</div>
              <Button color="primary" variant="contained" style={{ width: 200, marginTop: 25 }} onClick={handleLogout}>
                Sair
              </Button>
            </Grid>
          </CardContent>
        </Card>
      </div>
     

    </div>
  );
}

export default PerfilView;
